import { useDispatch } from 'react-redux'
import React from 'react';
// project imports
import Grid from "@mui/material/Grid";
import PageHeader from "../../ui-component/cards/PageHeader";
import { gridSpacing } from "../../store/constant";
import UserServices from '../../services/UserServices';
import { useEffect, useState } from 'react';
import Datatable from '../../datatables/Datatable';
import { registeredUserColumns } from '../../datatables/rowsColumn';
import { useTranslation } from 'react-i18next';
import { Alert, Snackbar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';
import tableTheme from "../../ui-component/customTableUi";
import { ThemeProvider } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import Paper from "@mui/material/Paper";
import MenuItem from "@mui/material/MenuItem";
import DownloadIcon from "@mui/icons-material/Download";
import ClearIcon from "@mui/icons-material/Clear";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PrintIcon from "@mui/icons-material/Print";
const generateDummyManufacturerUsers = () => {
  const dummyUsers = [];
  for (let i = 1; i <= 51; i++) {
    dummyUsers.push({
      id: 100000 + i,
      role: 'devicemanufacture',
      name: `Dummy Manufacturer User ${i}`,
      email: `dummy.manufacturer${i}@example.com`,
      mobile: `9000000${String(i).padStart(3, '0')}`,
      status: 'active',
      created_by_name: 'system_admin',
      created: new Date('2025-01-01').toISOString(),
      is_active: true,
      expirydate: null,
    });
  }
  return dummyUsers;
};

const UsersList = () => {
  const { t } = useTranslation();
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
const [showFilters, setShowFilters] = useState(false);

const defaultFilters = {
  name: "",
  email: "",
  mobile: "",
  role: "",
  status: "",
  login: "",
  is_active: "",
  usertype: "",
  address: "",
  created: "",
  created_from: "",
  created_to: "",
  date_joined: "",
  date_joined_from: "",
  date_joined_to: "",
  expirydate: "",
  expirydate_from: "",
  expirydate_to: "",
  created_by_name: "",
};

const [filters, setFilters] = useState(defaultFilters);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    userId: null,
    userName: ''
  });

  const fetchUsers = async (payload = defaultFilters) => {
  try {
    setLoad(false);

    const response = await UserServices.getRegisteredUsers(payload);

  const apiUsers = response?.data || [];

setUsers(Array.isArray(apiUsers) ? apiUsers : []);

    setLoad(true);
  } catch (err) {
    console.log(err);

    setUsers([]);

    setLoad(true);
  }
};

useEffect(() => {
  fetchUsers(defaultFilters);
}, []);

useEffect(() => {
  const timer = setTimeout(() => {
    fetchUsers({
      ...filters,
      name: searchText,
    });
  }, 500);

  return () => clearTimeout(timer);
}, [searchText]);

const applyFilter = () => {
  fetchUsers({
    ...filters,
    name: searchText,
  });
};

const clearFilter = () => {
  setFilters(defaultFilters);

  setSearchText("");

  fetchUsers(defaultFilters);
};

const downloadExcel = async () => {
  try {
    const response = await UserServices.getRegisteredUsers({
      ...filters,
      name: searchText,
    });

    const data = response?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      alert("No data found");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Users"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Users.xlsx");
  } catch (err) {
    console.log(err);
  }
};

const printUsers = async () => {
  try {
    const response = await UserServices.getRegisteredUsers({
      ...filters,
      name: searchText,
    });

    const data = response?.data || [];

    if (!Array.isArray(data) || data.length === 0) {
      alert("No data found");
      return;
    }

    const html = `
      <html>
      <head>
        <title>Users List</title>
        <style>
          body{
            font-family: Arial, sans-serif;
            padding:20px;
          }

          h2{
            text-align:center;
            margin-bottom:20px;
          }

          table{
            width:100%;
            border-collapse:collapse;
          }

          th,td{
            border:1px solid #000;
            padding:8px;
            text-align:left;
            font-size:12px;
          }

          th{
            background:#f5f5f5;
          }
        </style>
      </head>

      <body>
        <h2>Users List</h2>

        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Role</th>
              <th>Status</th>
              <th>Created By</th>
              <th>Expiry Date</th>
            </tr>
          </thead>

          <tbody>
            ${data
              .map(
                (item) => `
                <tr>
                  <td>${item.name || ""}</td>
                  <td>${item.email || ""}</td>
                  <td>${item.mobile || ""}</td>
                  <td>${item.role || ""}</td>
                  <td>${item.status || ""}</td>
                  <td>${item.created_by_name || ""}</td>
                  <td>${item.expirydate || ""}</td>
                </tr>
              `
              )
              .join("")}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.focus();
    printWindow.print();
    printWindow.close();
  } catch (err) {
    console.log(err);
  }
};

  const handleDeactivateUser = async (userId) => {
    try {
      const response = await UserServices.deactivateUser({ userid: userId });
      if (response.status === 200) {
        // Refresh the user list
        await fetchUsers({
  ...filters,
  name: searchText,
});

        // Show success message
        setNotification({
          open: true,
          message: 'User deactivated successfully',
          severity: 'success'
        });
      }
    } catch (error) {
      console.error('Error deactivating user:', error);
      setNotification({
        open: true,
        message: 'Failed to deactivate user',
        severity: 'error'
      });
    } finally {
      setConfirmDialog({ open: false, userId: null, userName: '' });
    }
  };

  const handleReactivateUser = async (userId) => {
    try {
      const response = await UserServices.activateUser({ userid: userId });
      if (response.status === 200) {
        await fetchUsers({
  ...filters,
  name: searchText,
});

        setNotification({
          open: true,
          message: 'User reactivated successfully',
          severity: 'success'
        });
      }
    } catch (error) {
      console.error('Error reactivating user:', error);
      setNotification({
        open: true,
        message: 'Failed to reactivate user',
        severity: 'error'
      });
    }
  };



  const handleCloseNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  const handleOpenConfirmDialog = (userId, userName) => {
    setConfirmDialog({
      open: true,
      userId,
      userName
    });
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialog({ open: false, userId: null, userName: '' });
  };

  // Add deactivate button to columns
  const columnsWithActions = [
    ...registeredUserColumns,
    {
      name: "expirydate",
      label: "Expiry Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value ? new Date(value).toLocaleDateString('en-GB') : 'N/A'
      }
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          // Note: tableMeta.rowData contains raw values from API (timestamps, where present, are in GMT/UTC).
          const userId = tableMeta.rowData[0]; // Assuming id is the first column
          const userName = tableMeta.rowData[2]; // Assuming name is the third column
          const isActive = !!tableMeta.rowData[8]; // is_active hidden column
          const currentExpiry = tableMeta.rowData[9]; // expirydate column we just added (index 9)

          return (
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => isActive ? handleOpenConfirmDialog(userId, userName) : handleReactivateUser(userId)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: isActive ? '#ff4444' : '#34c759',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                {isActive ? 'Deactivate' : 'Reactivate'}
              </button>
            </div>
          );
        }
      }
    }
  ];

  const filteredUsers = users.filter((user) => {
  const matchesSearch =
    searchText === "" ||
    user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    user.email?.toLowerCase().includes(searchText.toLowerCase()) ||
    user.mobile?.includes(searchText);

  const matchesRole =
    !filters.role || user.role === filters.role;

  const matchesStatus =
    !filters.status || user.status === filters.status;

  const matchesMobile =
    !filters.mobile || user.mobile?.includes(filters.mobile);

  const matchesEmail =
    !filters.email ||
    user.email?.toLowerCase().includes(filters.email.toLowerCase());

  return (
    matchesSearch &&
    matchesRole &&
    matchesStatus &&
    matchesMobile &&
    matchesEmail
  );
});

return (
  <Grid container spacing={gridSpacing}>
    <Grid item xs={12}>
      <PageHeader title={t("users.listTitle")} />
    </Grid>

    <Grid item xs={12}>

      {/* Search & Action Buttons */}
<Grid container spacing={2} sx={{ mb: 2 }}>
  <Grid item xs={12} md={6}>
    <TextField
      fullWidth
      size="small"
      placeholder="Search Name"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
  </Grid>

  <Grid
    item
    xs={12}
    md={6}
    display="flex"
    justifyContent="flex-end"
  >
    <Button
      variant="outlined"
      startIcon={<FilterListIcon />}
      onClick={() => setShowFilters((prev) => !prev)}
      sx={{ mr: 1 }}
    >
      Filter
    </Button>

    <Button
      variant="outlined"
      color="success"
      startIcon={<DownloadIcon />}
      onClick={downloadExcel}
      sx={{ mr: 1 }}
    >
      Download
    </Button>

    <Button
      variant="outlined"
      color="error"
      startIcon={<ClearIcon />}
      onClick={clearFilter}
      sx={{ mr: 1 }}
    >
      Clear
    </Button>

    <Button
  variant="outlined"
  color="primary"
  startIcon={<PrintIcon />}
  onClick={printUsers}
  sx={{ mr: 1 }}
>
  Print
</Button>
  </Grid>
</Grid>

{/* Filter Panel */}
{showFilters && (
  <Paper
    sx={{
      p: 2,
      mb: 2,
      border: "1px solid #ddd",
      borderRadius: 2,
    }}
  >
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Role"
          value={filters.role}
          onChange={(e) =>
            setFilters({
              ...filters,
              role: e.target.value,
            })
          }
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="owner">Owner</MenuItem>
          <MenuItem value="dealer">Dealer</MenuItem>
          <MenuItem value="devicemanufacture">
            Manufacturer
          </MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          size="small"
          label="Email"
          value={filters.email}
          onChange={(e) =>
            setFilters({
              ...filters,
              email: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          size="small"
          label="Mobile"
          value={filters.mobile}
          onChange={(e) =>
            setFilters({
              ...filters,
              mobile: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Status"
          value={filters.status}
          onChange={(e) =>
            setFilters({
              ...filters,
              status: e.target.value,
            })
          }
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="retired">Rejected</MenuItem>
        </TextField>
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          size="small"
          label="Created By"
          value={filters.created_by_name}
          onChange={(e) =>
            setFilters({
              ...filters,
              created_by_name: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          type="date"
          fullWidth
          size="small"
          label="Created From"
          InputLabelProps={{ shrink: true }}
          value={filters.created_from}
          onChange={(e) =>
            setFilters({
              ...filters,
              created_from: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextField
          type="date"
          fullWidth
          size="small"
          label="Created To"
          InputLabelProps={{ shrink: true }}
          value={filters.created_to}
          onChange={(e) =>
            setFilters({
              ...filters,
              created_to: e.target.value,
            })
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          onClick={applyFilter}
        >
          Apply Filter
        </Button>
      </Grid>
    </Grid>
  </Paper>
)}

{/* Datatable */}
<ThemeProvider theme={tableTheme}>
  {load && (
    <Datatable
      tableTitle=""
      userRows={users}
      userColumns={columnsWithActions}
      helperText="Timestamps are in GMT/UTC."
      options={{
        search: false,
        filter: false,
        download: false,
        print: false,
        selectableRows: "none",
      }}
    />
  )}
</ThemeProvider>

      {/* Filter Panel */}
      {/* {showFilters && (
        <Paper sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={2}>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="small"
                label="Role"
                value={filters.role}
                onChange={(e) =>
                  setFilters({ ...filters, role: e.target.value })
                }
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="owner">Owner</MenuItem>
                <MenuItem value="dealer">Dealer</MenuItem>
                <MenuItem value="devicemanufacture">
                  Manufacturer
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                size="small"
                label="Status"
                value={filters.status}
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value })
                }
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="retired">Rejected</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Mobile"
                value={filters.mobile}
                onChange={(e) =>
                  setFilters({ ...filters, mobile: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Email"
                value={filters.email}
                onChange={(e) =>
                  setFilters({ ...filters, email: e.target.value })
                }
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                type="date"
                fullWidth
                size="small"
                label="From Date"
                InputLabelProps={{ shrink: true }}
                value={filters.fromDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    fromDate: e.target.value,
                  })
                }
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                type="date"
                fullWidth
                size="small"
                label="To Date"
                InputLabelProps={{ shrink: true }}
                value={filters.toDate}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    toDate: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </Paper>
      )} */}

      {/* Datatable */}
      {/* <ThemeProvider theme={tableTheme}>
        {load && (
          <Datatable
            tableTitle=""
            userRows={filteredUsers}
            userColumns={columnsWithActions}
            helperText="Timestamps are in GMT/UTC."
            options={{
        search: false,
        filter: false,
        download: false,
        print: false,
    }}
          />
        )}
      </ThemeProvider> */}

    </Grid>

    <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={handleCloseNotification}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleCloseNotification}
        severity={notification.severity}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>

    <Dialog
      open={confirmDialog.open}
      onClose={handleCloseConfirmDialog}
    >
      <DialogTitle>
        Confirm Deactivation
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {t("common.deleteDialog", {
            userName: confirmDialog.userName,
          })}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseConfirmDialog}>
          Cancel
        </Button>

        <Button
          color="error"
          autoFocus
          onClick={() =>
            handleDeactivateUser(confirmDialog.userId)
          }
        >
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  </Grid>
);
}

export default UsersList